import React from 'react';
import TableWithSummary from '../../../../../../components/table/TableWithSummary';
import { LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import {
  PRODUCT_LIST_FILTER_OPTION_MODEL,
  PRODUCT_PROPERTY_REQUEST_LIST_SORT_OPTION_MODEL,
} from '../../../../../../store/modules/product/models';
import { PRODUCT_TAG_REQUEST_LIST_TABLE_EMPTY_TEXT } from '../../../../../../constants/service/app/productConstants';
import columns from './columns';

const ProductPropertyRequestList = (props) => {
  const {
    categorySelectList,
    productListInfo,
    getProductSubCategoryList,
    getList,
    getExcelDownload,
    mainProductCategorySelectList,
    subProductCategorySelectList,
  } = props;
  const { list, filterOption, sortOption, pagination, summary } = productListInfo;

  return (
    <div className="product-tag-request-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: PRODUCT_LIST_FILTER_OPTION_MODEL,
          sortOption: PRODUCT_PROPERTY_REQUEST_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={PRODUCT_TAG_REQUEST_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) =>
          columns({
            categorySelectList,
            getProductSubCategoryList,
            mainProductCategorySelectList,
            subProductCategorySelectList,
            ...utils,
          })
        }
      />
    </div>
  );
};

export default ProductPropertyRequestList;
